import axios from "axios";
import qs from "qs";
import { api } from "@/plugins/util";

export function getYxdwList({ dwName, uscc, dwStatus, current }) {
    let pageNum = current;
    return axios.post(api + "/yxdw/list", qs.stringify({
        dwName,
        uscc,
        dwStatus,
        pageNum
     })

    );
}

export function findYxdwList(){
    return axios.post(api+"/yxdw/findYxdwList");
}

/**
 * 上传
 * @param {} file
 */
export function uoloadFile(formData){
    return axios({
        url: api + "/xydaSelect/upload",
        method: "post",
        data: formData,
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
    });
}


export function addYxdw({ full_name,short_name,organization_type,region,address,introduction,logo,sort,orgCode,orgName,uniscId }) {
    return axios.post(api + "/yxdw/add", qs.stringify({
        full_name,short_name,organization_type,region,address,introduction,logo,sort,orgCode,orgName,uniscId
        })
    );
}


export function updateYxdw({ id, full_name,short_name,organization_type,region,address,introduction,logo,sort,orgCode,orgName,uniscId }) {
    return axios.post(api + "/yxdw/update", qs.stringify({
            id, full_name,short_name,organization_type,region,address,introduction,logo,sort,orgCode,orgName,uniscId
        })
    );
}

export function disable({ id }){
    let idsStr = id;
    return axios.post(api + "/yxdw/disable", qs.stringify({
            idsStr
        })
    );
}

export function enable({ id }){
    let idsStr = id;
    return axios.post(api + "/yxdw/enable", qs.stringify({
            idsStr
        })
    );
}

/**
 *
 * 判断手机号是否已被注册
 */
export function checkPhoe(phone){
    return axios.post(api + "/yxdw/checkPhone", qs.stringify({
            phone
        })
    );
}

/**
 * 审核记录
 *
 */
export function getHisInfos(yxdwId,pageNum){
    return axios.get(api + "/yxdw/showHistoryInfo",{
        params:{
            yxdwId,
            pageNum
        }
    })
}

/**
 * 获取单位类型
 *
 */
export function getTypes(mark){
    return axios.get(api + "/sysParam/select",{
        params:{
            mark
        }
    })
}
/**
 *
 * 获取提醒设置
 */
export function getRemind(){
    return axios.post(api + "/yxdw/getRemind", qs.stringify({

        })
    );
}
/**
 *
 * 判断手机号是否已被注册
 */
export function updateRemind(type,phone){
    return axios.post(api + "/yxdw/updateRemind", qs.stringify({
            type,phone
        })
    );
}

/**
 * 获取机构字典信息列表
 * @returns {AxiosPromise<any>}
 */
export function getOrgInfoList(name,orgCode) {
    return axios.get(api + "/yxdw/getOrgInfoList",{
        params:{
            name,
            orgCode
        }
    })
}
